import { LoyaltyBalance } from '@/types/loyalty-balance';
import api from '@/utils/api';

// Backend nests the customer's loyalty balance under /loyalty (the
// "Intelli Points" feature is feature-flagged off per plan §6.4 — the
// endpoint returns zeroed values when disabled).
export const getLoyaltyBalance = (): Promise<LoyaltyBalance> =>
  api.get('/loyalty/balance/me', {
    next: { revalidate: 0 },
  });
